import { render, staticRenderFns } from "./FormReportButtons.vue?vue&type=template&id=0210e518&scoped=true&"
import script from "./FormReportButtons.vue?vue&type=script&lang=js&"
export * from "./FormReportButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormReportButtons.vue?vue&type=style&index=0&id=0210e518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210e518",
  null
  
)

export default component.exports